import { Badge } from '@radix-ui/themes';
import { RX } from 'enums/radix';
import { AuthRole } from 'lib/enums/auth';
import { useMemo } from 'react';

export const BadgeUserRole = (props: { value: AuthRole }) => {
  const color = useMemo(() => {
    switch (props.value) {
      case AuthRole.Admin: {
        return RX.CLR.ADMIN;
      }

      case AuthRole.Dealer: {
        return RX.CLR.DEALER;
      }

      default: {
        return undefined;
      }
    }
  }, [props.value]);

  return <Badge color={color}>{props.value.toUpperCase()}</Badge>;
};
